import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form__row" }
const _hoisted_2 = { class: "form__column half-width" }
const _hoisted_3 = { for: "firstName" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "form__column half-width" }
const _hoisted_6 = { for: "lastName" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "form__column" }
const _hoisted_9 = { for: "phoneNumber" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "form__column" }
const _hoisted_12 = { for: "email" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "form__column" }
const _hoisted_15 = { for: "message" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = {
  class: "form__button button--base button--primary",
  type: "submit"
}
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 0,
  class: "form-block__response-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendEmail && _ctx.sendEmail(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("ContactForm.FirstName")), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "firstName",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contactForm.firstName) = $event)),
          placeholder: _ctx.$t("ContactForm.FirstNamePlaceholder")
        }, null, 8, _hoisted_4), [
          [_vModelText, _ctx.contactForm.firstName]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("ContactForm.LastName")), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "lastName",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contactForm.lastName) = $event)),
          placeholder: _ctx.$t("ContactForm.LastNamePlaceholder")
        }, null, 8, _hoisted_7), [
          [_vModelText, _ctx.contactForm.lastName]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("ContactForm.PhoneNumber")), 1),
      _withDirectives(_createElementVNode("input", {
        type: "tel",
        id: "phoneNumber",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contactForm.phoneNumber) = $event)),
        placeholder: _ctx.$t("ContactForm.PhoneNumberPlaceholder")
      }, null, 8, _hoisted_10), [
        [_vModelText, _ctx.contactForm.phoneNumber]
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("ContactForm.Email")), 1),
      _withDirectives(_createElementVNode("input", {
        type: "email",
        id: "email",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contactForm.email) = $event)),
        placeholder: _ctx.$t("ContactForm.EmailPlaceholder")
      }, null, 8, _hoisted_13), [
        [_vModelText, _ctx.contactForm.email]
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("ContactForm.Message")), 1),
      _withDirectives(_createElementVNode("textarea", {
        id: "message",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contactForm.message) = $event)),
        placeholder: _ctx.$t("ContactForm.MessagePlaceholder")
      }, null, 8, _hoisted_16), [
        [_vModelText, _ctx.contactForm.message]
      ])
    ]),
    _createElementVNode("button", _hoisted_17, _toDisplayString(_ctx.$t("ContactForm.Send")), 1),
    _createElementVNode("div", {
      class: "form-block__policy-text",
      innerHTML: _ctx.policy
    }, null, 8, _hoisted_18),
    (_ctx.displayResponseMsg)
      ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.responseMsg), 1))
      : _createCommentVNode("", true)
  ], 32))
}